<template>
  <div class="row q-col-gutter-x-sm">
    <div v-for="option in options" :key="option.value" class="col">
      <SAICardToggle
        spread
        :error="error"
        :active="option.value === value"
        :disable="disable"
        @click="$emit('input', option.value)"
      >
        <p class="text-weight-medium q-py-md">{{ option.label }}</p>
      </SAICardToggle>
    </div>
  </div>
</template>

<script>
import { SAICardToggle } from 'ecx.saigon.ui.common';

export default {
  name: 'NewUsedList',
  props: {
    value: undefined,
    disable: Boolean,
    error: Boolean
  },
  data() {
    return {
      options: Object.values(this.$Constants.NEW_USED_LIST)
    };
  },
  components: {
    SAICardToggle
  }
};
</script>
